import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  deleteUser,
} from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDvF4tl2JYYB7tY-kLepiQPmrW0uCovwpw",
  authDomain: "internkaro-fa3ba.firebaseapp.com",
  projectId: "internkaro-fa3ba",
  storageBucket: "internkaro-fa3ba.firebasestorage.app",
  messagingSenderId: "371105529962",
  appId: "1:371105529962:web:6d9f666dc17af5f30f8a13",
  measurementId: "G-2VYNKHDQK1"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

export {
  auth,
  db,
  functions,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  deleteUser,
  doc,
  setDoc,
  getDoc,
};
